import { render } from "./formColumn.vue?vue&type=template&id=04d37e0b"
import script from "./formColumn.vue?vue&type=script&lang=js"
export * from "./formColumn.vue?vue&type=script&lang=js"

import "./formColumn.vue?vue&type=style&index=0&id=04d37e0b&lang=scss"

import exportComponent from "D:\\新建文件夹\\workPage\\OA H5\\stgd.oa.mobile.h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__